<template>
    <div class="onboarding">
        <div class="page container center">
            <h1 class="title">Redirecting you to the city page...</h1>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                currentCity: '',
                allLocationsObj: {}
            }
        },
        beforeMount(){

            this.currentCity = this.$route.params.id
            this.allLocationsObj = this.$store.state.locations

            let routeUrl = false
            let newLocation = null
            
            if(this.currentCity !== ''){

                newLocation = this.allLocationsObj[this.currentCity]

                if(newLocation !== null && typeof(newLocation) !== 'undefined'){
                    routeUrl = true
                }
            }

            if(routeUrl){
                
                window.localStorage.setItem('defaultLocation', newLocation.city)

                this.$store.dispatch('updateLocation', newLocation)
            }

            this.$router.push('/')
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/City.vue